export const defaultCdnImageQuality = 75;

export const defaultCdnImageFormat = 'auto';

export const stagingCdnUrl = 'https://cdn.cms.staging.waskurzes.com';

export const liveCdnUrl = 'https://cdn.bitpanda.com';
